import { useState, useEffect } from "react";

import BackgroundVideo from "./components/BackgroundVideo";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import Home from "./pages/home";
import AboutMe from "./pages/aboutme";
import Projects from "./pages/projects";
import Music from "./pages/music";

function App() {
  const [activePage, setActivePage] = useState("HOME");
  
  useEffect(() => {
    window.scrollTo(0,0);
  }, [activePage]);

  const getPageComponent = () => {
    switch(activePage) {
      case "HOME":
        return <Home />;
      case "ABOUT ME":
        return <AboutMe />;
      case "CODING":
        return <Projects />;
      case "MUSIC":
        return <Music />;
      default:
        return <Home />;
    }
  }

  return (
    <div>
        <BackgroundVideo/>
        <NavBar setActivePage={setActivePage}/>
        <div style={{
            minHeight: '90vh',
            width: '100vw',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            overflow: 'auto',
            paddingTop: '10vh',
            paddingBottom: '10vh'
          }}
        >
          {getPageComponent()}
        </div>
        <Footer/>
      </div>
  );
}

export default App;
